<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="400px"
    class="member-limit-dialog-box "
    :mask-closable="false"
    :footer="null"
    @cancel="TipDialogVisible=false"
  >
    <div
      class="dialog-tip-box dialog-tip-blue"
    >
      <i class="icon iconfont iconicon-test34" />
      <h2>{{ $t('message["430"]') }}？</h2>
      <div class="d-tip-con">
        <p>
          {{ accountTipt[0] }}{{ value }} }{{ accountTipt[1] }}
          <template v-if="baseinfo.bind_dingding === 1">
            {{ $t('message["238"]') }}
          </template><template v-if="baseinfo.bind_qiwei === 1">
            {{ $t('message["720"]') }}
          </template>
          {{ $t('message["592"]') }}
        </p>
        <p>{{ $t('message["952"]') }}.</p>
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="triggerMerge"
        >
          {{ $t('message["596"]') }}
        </a-button>
        <a-button
          class="ml-16"
          @click="resetHandle"
        >
          {{ $t('message["1277"]') }}
        </a-button>
        <merge-form ref="mergeForm" />
      </div>
    </div>
  </a-modal>
</template>
<script>
import MergeForm from './MergeForm'
import { mapActions } from 'vuex'
export default {
  components: {
    MergeForm
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      TipDialogVisible: this.visible,
      submiting: false
    }
  },
  computed: {
    baseinfo () {
      return this.$store.state.baseinfo
    },
    accountTipt () {
      return this.$t('message["180"]').split('|')
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('merge', ['ajaxNoNotice']),
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    triggerMerge (val) {
      this.TipDialogVisible = false
      this.$refs.mergeForm.changeVisible(true)
    },
    async resetHandle () {
      let res = await this.ajaxNoNotice()
      res.onSuccess(res => {
        this.TipDialogVisible = false
        this.$message.success(this.$t('message["81"]') + '！')
      })
        .fetch()
    }
  }
}
</script>
